export default "__VITE_ASSET__938b17a2__"